/* eslint-disable you-dont-need-lodash-underscore/drop */
import _ from 'lodash';
import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';
import { getLevelItems } from '../../content/curriculum';

export const initialState = {
  roundNumber: 1,
  numQuestions: 0,
  questions: [],
  currentQuestion: {},
  answerAttempts: 0,
  questionsCorrect: 0,
  questionsAnswered: 0,
  movedQuestionIds: [],
  selectedTile: null,
  selectedTiles: [],
  questionIsSimplified: false,
};

let questions = [];

const roundReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_ROUND:
      questions = getLevelItems(action.payload.roundNumber);
      return {
        ...initialState,
        roundNumber: action.payload.roundNumber,
        questions: _.drop(questions, 1),
        numQuestions: questions.length,
        currentQuestion: _.head(questions),
      };
    case REDUX_ACTIONS.SIMPLIFY_QUESTION:
      return {
        ...state,
        questionIsSimplified: true,
        selectedTile: null,
      };
    case REDUX_ACTIONS.NEXT_QUESTION: {
      return {
        ...state,
        currentQuestion: _.head(state.questions),
        questions: _.drop(state.questions, 1),
        selectedTile: null,
        selectedTiles: [],
        questionIsSimplified: false,
        answerAttempts: 0,
      };
    }
    case REDUX_ACTIONS.SELECT_TILE:
      return {
        ...state,
        selectedTile: action.payload.selectedTile,
        selectedTiles: [
          ...state.selectedTiles,
          action.payload.selectedTile,
        ],
      };
    case REDUX_ACTIONS.MOVE_QUESTION_TO_THE_END:
      questions = state.questions.slice();
      questions.push({ ...state.currentQuestion });

      return {
        ...state,
        questions,
        movedQuestionIds: [
          ...state.movedQuestionIds,
          state.currentQuestion.questionId,
        ],
      };
    case REDUX_ACTIONS.INCREMENT_ANSWER_ATTEMPTS:
      return {
        ...state,
        answerAttempts: state.answerAttempts + 1,
      };
    case REDUX_ACTIONS.INCREMENT_QUESTIONS_CORRECT:
      return {
        ...state,
        questionsCorrect: state.questionsCorrect + 1,
      };
    case REDUX_ACTIONS.INCREMENT_QUESTIONS_ANSWERED:
      return {
        ...state,
        questionsAnswered: state.questionsAnswered + 1,
      };
    case REDUX_ACTIONS.RESET_SELECTED_TILE:
      return {
        ...state,
        selectedTile: null,
      };
    case REDUX_ACTIONS.QUICK_ROUND:
      return {
        ...state,
        questionsCorrect: action.payload.isSuccess ? state.numQuestions : 0,
      };
    default:
      return state;
  }
};

export default roundReducer;
